
/* !!! This is code generated by Prisma. Do not edit directly. !!!
/* eslint-disable */

Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.11.1
 * Query Engine version: f40f79ec31188888a2e33acda0ecc8fd10a853a9
 */
Prisma.prismaVersion = {
  client: "6.11.1",
  engine: "f40f79ec31188888a2e33acda0ecc8fd10a853a9"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires'
};

exports.Prisma.VerificationTokenScalarFieldEnum = {
  identifier: 'identifier',
  token: 'token',
  expires: 'expires'
};

exports.Prisma.UrlScalarFieldEnum = {
  value: 'value',
  userId: 'userId'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  emailVerified: 'emailVerified',
  image: 'image',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  bio: 'bio',
  role: 'role',
  termsAccepted: 'termsAccepted'
};

exports.Prisma.UserPreferencesScalarFieldEnum = {
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  darkMode: 'darkMode',
  currency: 'currency',
  language: 'language'
};

exports.Prisma.UserSubscriptionFiatScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  customerId: 'customerId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.UserSubscriptionUsageScalarFieldEnum = {
  customerId: 'customerId',
  portfolioLimit: 'portfolioLimit',
  transactionLimit: 'transactionLimit',
  syncsPerDay: 'syncsPerDay',
  supportLevel: 'supportLevel',
  macroEconomy: 'macroEconomy',
  assetScreener: 'assetScreener',
  apiAccess: 'apiAccess',
  commercialUse: 'commercialUse',
  periodStart: 'periodStart',
  periodEnd: 'periodEnd',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SubscriptionPlanConfigScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  portfolioLimit: 'portfolioLimit',
  transactionLimit: 'transactionLimit',
  syncsPerDay: 'syncsPerDay',
  supportLevel: 'supportLevel',
  isPopular: 'isPopular',
  macroEconomy: 'macroEconomy',
  assetScreener: 'assetScreener',
  apiAccess: 'apiAccess',
  commercialUse: 'commercialUse'
};

exports.Prisma.AffiliateScalarFieldEnum = {
  id: 'id',
  isActive: 'isActive',
  code: 'code',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.PushNotificationPreferencesScalarFieldEnum = {
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  enabled: 'enabled',
  follow: 'follow',
  mention: 'mention',
  repost: 'repost',
  comment: 'comment',
  reaction: 'reaction',
  lastRead: 'lastRead'
};

exports.Prisma.PostScalarFieldEnum = {
  id: 'id',
  content: 'content',
  postId: 'postId',
  authorId: 'authorId',
  repostId: 'repostId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  draft: 'draft',
  pinned: 'pinned',
  visibility: 'visibility'
};

exports.Prisma.PostImageScalarFieldEnum = {
  id: 'id',
  postId: 'postId',
  url: 'url',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  expiry: 'expiry'
};

exports.Prisma.ReactionScalarFieldEnum = {
  userId: 'userId',
  postId: 'postId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  type: 'type'
};

exports.Prisma.PushSubscriptionScalarFieldEnum = {
  id: 'id',
  endpoint: 'endpoint',
  p256dh: 'p256dh',
  auth: 'auth',
  fcmToken: 'fcmToken',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId'
};

exports.Prisma.PushNotificationScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  readAt: 'readAt',
  payload: 'payload',
  senderId: 'senderId',
  type: 'type',
  meta: 'meta',
  severity: 'severity'
};

exports.Prisma.FollowsScalarFieldEnum = {
  followerId: 'followerId',
  followingId: 'followingId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.ChannelUserScalarFieldEnum = {
  userId: 'userId',
  channelId: 'channelId',
  role: 'role',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.ChannelScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  type: 'type'
};

exports.Prisma.MessageScalarFieldEnum = {
  id: 'id',
  channelId: 'channelId',
  userId: 'userId',
  content: 'content',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  replyToId: 'replyToId',
  editedAt: 'editedAt'
};

exports.Prisma.MessageReadByScalarFieldEnum = {
  messageId: 'messageId',
  readAt: 'readAt',
  userId: 'userId',
  channelId: 'channelId'
};

exports.Prisma.FileScalarFieldEnum = {
  id: 'id',
  name: 'name',
  url: 'url',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  messageId: 'messageId'
};

exports.Prisma.PortfolioScalarFieldEnum = {
  id: 'id',
  name: 'name',
  startingCapital: 'startingCapital',
  visibility: 'visibility',
  isAuthorVisible: 'isAuthorVisible',
  portfolioDetailsSubscriptionPrice: 'portfolioDetailsSubscriptionPrice',
  portfolioAlertsSubscriptionPrice: 'portfolioAlertsSubscriptionPrice',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  description: 'description',
  isPortfolioValueVisible: 'isPortfolioValueVisible',
  tournamentId: 'tournamentId'
};

exports.Prisma.PortfolioSourceScalarFieldEnum = {
  id: 'id',
  type: 'type',
  isActive: 'isActive',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  portfolioId: 'portfolioId'
};

exports.Prisma.ExchangeConnectionScalarFieldEnum = {
  id: 'id',
  provider: 'provider',
  apiKey: 'apiKey',
  secretKey: 'secretKey',
  passphrase: 'passphrase',
  extraParams: 'extraParams',
  sourceId: 'sourceId'
};

exports.Prisma.WalletConnectionScalarFieldEnum = {
  id: 'id',
  address: 'address',
  chain: 'chain',
  chainId: 'chainId',
  sourceId: 'sourceId'
};

exports.Prisma.CsvImportScalarFieldEnum = {
  id: 'id',
  fileName: 'fileName',
  lastImportedAt: 'lastImportedAt',
  sourceId: 'sourceId'
};

exports.Prisma.PortfolioNotificationPreferencesScalarFieldEnum = {
  portfolioId: 'portfolioId',
  enabled: 'enabled',
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
  yearly: 'yearly'
};

exports.Prisma.AssetScalarFieldEnum = {
  id: 'id',
  symbol: 'symbol',
  name: 'name',
  assetClass: 'assetClass',
  thirdPartyIds: 'thirdPartyIds',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.TransactionScalarFieldEnum = {
  id: 'id',
  portfolioId: 'portfolioId',
  userId: 'userId',
  assetId: 'assetId',
  amount: 'amount',
  price: 'price',
  cost: 'cost',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isValid: 'isValid',
  note: 'note',
  meta: 'meta',
  type: 'type',
  direction: 'direction'
};

exports.Prisma.TransactionTradeScalarFieldEnum = {
  id: 'id',
  transactionId: 'transactionId',
  createdAt: 'createdAt',
  orderType: 'orderType',
  quoteAssetId: 'quoteAssetId',
  quotePrice: 'quotePrice',
  quoteAmount: 'quoteAmount'
};

exports.Prisma.TransactionSwapScalarFieldEnum = {
  id: 'id',
  transactionId: 'transactionId',
  createdAt: 'createdAt',
  toAssetId: 'toAssetId',
  toAmount: 'toAmount',
  toPrice: 'toPrice',
  toCost: 'toCost',
  slippage: 'slippage',
  provider: 'provider',
  routingPath: 'routingPath'
};

exports.Prisma.TransactionDepositScalarFieldEnum = {
  id: 'id',
  transactionId: 'transactionId',
  createdAt: 'createdAt',
  fromAddress: 'fromAddress',
  txHash: 'txHash',
  network: 'network',
  status: 'status'
};

exports.Prisma.TransactionWithdrawalScalarFieldEnum = {
  id: 'id',
  transactionId: 'transactionId',
  createdAt: 'createdAt',
  toAddress: 'toAddress',
  txHash: 'txHash',
  network: 'network',
  status: 'status',
  reason: 'reason'
};

exports.Prisma.TransactionFeeScalarFieldEnum = {
  id: 'id',
  transactionId: 'transactionId',
  createdAt: 'createdAt',
  assetId: 'assetId',
  cost: 'cost',
  feeType: 'feeType'
};

exports.Prisma.TransactionFillScalarFieldEnum = {
  id: 'id',
  transactionId: 'transactionId',
  createdAt: 'createdAt',
  price: 'price',
  amount: 'amount',
  cost: 'cost'
};

exports.Prisma.PortfolioValueScalarFieldEnum = {
  portfolioId: 'portfolioId',
  value: 'value',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EnlistedUsersScalarFieldEnum = {
  id: 'id',
  email: 'email',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PartnerScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  description: 'description',
  logoUrl: 'logoUrl',
  coverImageUrl: 'coverImageUrl',
  socialLinks: 'socialLinks'
};

exports.Prisma.PartnerMemberScalarFieldEnum = {
  userId: 'userId',
  partnerId: 'partnerId'
};

exports.Prisma.TournamentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  description: 'description',
  coverImageUrl: 'coverImageUrl',
  startDate: 'startDate',
  endDate: 'endDate',
  winners: 'winners',
  prizes: 'prizes',
  partnerId: 'partnerId',
  userId: 'userId',
  winnersText: 'winnersText',
  finalLeaderboard: 'finalLeaderboard',
  visibility: 'visibility'
};

exports.Prisma.CoinMarketDataScalarFieldEnum = {
  coinGeckoId: 'coinGeckoId',
  timestamp: 'timestamp',
  price: 'price',
  marketCap: 'marketCap',
  volume: 'volume',
  updatedAt: 'updatedAt'
};

exports.Prisma.PostStatsScalarFieldEnum = {
  postId: 'postId',
  reactionsCount: 'reactionsCount',
  commentsCount: 'commentsCount',
  repostsCount: 'repostsCount'
};

exports.Prisma.PortfolioAssetTransactionViewScalarFieldEnum = {
  portfolioId: 'portfolioId',
  portfolioName: 'portfolioName',
  assetId: 'assetId',
  assetName: 'assetName',
  symbol: 'symbol',
  totalAmount: 'totalAmount',
  totalCost: 'totalCost',
  averageCost: 'averageCost',
  transactionCount: 'transactionCount',
  totalFee: 'totalFee',
  lastTransactionAt: 'lastTransactionAt'
};

exports.Prisma.FirstCreatedPortfoliosViewScalarFieldEnum = {
  userId: 'userId',
  portfolioId: 'portfolioId'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.UserRole = exports.$Enums.UserRole = {
  ADMIN: 'ADMIN',
  USER: 'USER',
  PRO: 'PRO'
};

exports.SupportLevel = exports.$Enums.SupportLevel = {
  LOW: 'LOW',
  NORMAL: 'NORMAL',
  HIGH: 'HIGH',
  DEDICATED: 'DEDICATED'
};

exports.ContentVisibility = exports.$Enums.ContentVisibility = {
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE',
  FOLLOWERS: 'FOLLOWERS',
  SUBSCRIBERS: 'SUBSCRIBERS'
};

exports.ReactionType = exports.$Enums.ReactionType = {
  LIKE: 'LIKE',
  DISLIKE: 'DISLIKE',
  BULLISH: 'BULLISH',
  BEARISH: 'BEARISH',
  INFORMATIVE: 'INFORMATIVE',
  INSIGHTFUL: 'INSIGHTFUL',
  FUNNY: 'FUNNY',
  CONFUSING: 'CONFUSING'
};

exports.PushNotificationSeverity = exports.$Enums.PushNotificationSeverity = {
  LOW: 'LOW',
  DEFAULT: 'DEFAULT',
  HIGH: 'HIGH',
  CRITICAL: 'CRITICAL'
};

exports.MemberRole = exports.$Enums.MemberRole = {
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
  MODERATOR: 'MODERATOR'
};

exports.ChannelType = exports.$Enums.ChannelType = {
  PRIVATE: 'PRIVATE',
  DIRECT: 'DIRECT',
  GROUP: 'GROUP',
  SUBSCRIBERS: 'SUBSCRIBERS',
  FOLLOWERS: 'FOLLOWERS'
};

exports.PortfolioSourceType = exports.$Enums.PortfolioSourceType = {
  MANUAL: 'MANUAL',
  EXCHANGE_API: 'EXCHANGE_API',
  CRYPTO_WALLET: 'CRYPTO_WALLET',
  CSV_IMPORT: 'CSV_IMPORT'
};

exports.ExchangeProvider = exports.$Enums.ExchangeProvider = {
  BINANCE: 'BINANCE',
  BITGET: 'BITGET',
  BITFINEX: 'BITFINEX',
  BYBIT: 'BYBIT',
  CRYPTOCOM: 'CRYPTOCOM',
  GATEIO: 'GATEIO',
  COINBASE: 'COINBASE',
  KRAKEN: 'KRAKEN',
  KUCOIN: 'KUCOIN',
  OKX: 'OKX'
};

exports.BlockchainType = exports.$Enums.BlockchainType = {
  BITCOIN: 'BITCOIN',
  ETHEREUM: 'ETHEREUM',
  LITECOIN: 'LITECOIN',
  DOGECOIN: 'DOGECOIN',
  DASH: 'DASH',
  TRON: 'TRON',
  BITLAYER: 'BITLAYER',
  OPBNB: 'OPBNB',
  BOB: 'BOB',
  BEVM: 'BEVM',
  FANTOM: 'FANTOM',
  GNOSIS: 'GNOSIS',
  BASE: 'BASE',
  SCROLL: 'SCROLL',
  MANTA: 'MANTA',
  OMEGA: 'OMEGA',
  BLAST: 'BLAST',
  APE: 'APE',
  ARBITRUM: 'ARBITRUM',
  OPTIMISM: 'OPTIMISM',
  LINEA: 'LINEA',
  ZKSYNC: 'ZKSYNC',
  POLYGON: 'POLYGON',
  POLYGON_ZKEVM: 'POLYGON_ZKEVM',
  BSC: 'BSC',
  AVAXC: 'AVAXC',
  OKTC: 'OKTC',
  BITCOIN_CASH: 'BITCOIN_CASH',
  ETHEREUM_CLASSIC: 'ETHEREUM_CLASSIC',
  ETHW: 'ETHW',
  DIS: 'DIS',
  CANTO: 'CANTO',
  KAIA: 'KAIA',
  RONIN: 'RONIN',
  BEACON: 'BEACON',
  STARKNET: 'STARKNET',
  XLAYER: 'XLAYER',
  GRAVITY: 'GRAVITY',
  B2: 'B2',
  DUCKCHAIN: 'DUCKCHAIN',
  APTOS: 'APTOS',
  SUI: 'SUI',
  COSMOS: 'COSMOS',
  KAVA: 'KAVA',
  SOLANA: 'SOLANA',
  SEPOLIA_TESTNET: 'SEPOLIA_TESTNET',
  GOERLI_TESTNET: 'GOERLI_TESTNET',
  MUMBAI_TESTNET: 'MUMBAI_TESTNET',
  AMOY_TESTNET: 'AMOY_TESTNET',
  POLYGON_ZKEVM_TESTNET: 'POLYGON_ZKEVM_TESTNET',
  XLAYER_TESTNET: 'XLAYER_TESTNET'
};

exports.AssetClass = exports.$Enums.AssetClass = {
  STOCKS: 'STOCKS',
  INDICES: 'INDICES',
  FOREX: 'FOREX',
  CRYPTO: 'CRYPTO',
  FUTURES: 'FUTURES',
  COMMODITIES: 'COMMODITIES',
  BONDS: 'BONDS'
};

exports.TransactionType = exports.$Enums.TransactionType = {
  BUY: 'BUY',
  SELL: 'SELL',
  CLOSE: 'CLOSE',
  TRADE: 'TRADE',
  DEPOSIT: 'DEPOSIT',
  WITHDRAW: 'WITHDRAW',
  SWAP: 'SWAP',
  FILL: 'FILL',
  FEE: 'FEE'
};

exports.TransactionDirection = exports.$Enums.TransactionDirection = {
  IN: 'IN',
  OUT: 'OUT'
};

exports.OrderType = exports.$Enums.OrderType = {
  MARKET: 'MARKET',
  LIMIT: 'LIMIT'
};

exports.DepositStatus = exports.$Enums.DepositStatus = {
  PENDING: 'PENDING',
  CONFIRMED: 'CONFIRMED',
  FAILED: 'FAILED'
};

exports.WithdrawStatus = exports.$Enums.WithdrawStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
};

exports.WithdrawReason = exports.$Enums.WithdrawReason = {
  ONGOING_COST: 'ONGOING_COST',
  DIVIDEND: 'DIVIDEND',
  YIELD: 'YIELD',
  PROFIT_TAKING: 'PROFIT_TAKING',
  REBALANCING: 'REBALANCING',
  EMERGENCY: 'EMERGENCY',
  TAX_PAYMENT: 'TAX_PAYMENT',
  MOVING_FUNDS: 'MOVING_FUNDS',
  PERSONAL: 'PERSONAL',
  OTHER: 'OTHER'
};

exports.FeeType = exports.$Enums.FeeType = {
  TRADING: 'TRADING',
  WITHDRAWAL: 'WITHDRAWAL',
  NETWORK: 'NETWORK',
  SWAP: 'SWAP',
  PLATFORM: 'PLATFORM'
};

exports.Prisma.ModelName = {
  Account: 'Account',
  Session: 'Session',
  VerificationToken: 'VerificationToken',
  Url: 'Url',
  User: 'User',
  UserPreferences: 'UserPreferences',
  UserSubscriptionFiat: 'UserSubscriptionFiat',
  UserSubscriptionUsage: 'UserSubscriptionUsage',
  SubscriptionPlanConfig: 'SubscriptionPlanConfig',
  Affiliate: 'Affiliate',
  PushNotificationPreferences: 'PushNotificationPreferences',
  Post: 'Post',
  PostImage: 'PostImage',
  Reaction: 'Reaction',
  PushSubscription: 'PushSubscription',
  PushNotification: 'PushNotification',
  Follows: 'Follows',
  ChannelUser: 'ChannelUser',
  Channel: 'Channel',
  Message: 'Message',
  MessageReadBy: 'MessageReadBy',
  File: 'File',
  Portfolio: 'Portfolio',
  PortfolioSource: 'PortfolioSource',
  ExchangeConnection: 'ExchangeConnection',
  WalletConnection: 'WalletConnection',
  CsvImport: 'CsvImport',
  PortfolioNotificationPreferences: 'PortfolioNotificationPreferences',
  Asset: 'Asset',
  Transaction: 'Transaction',
  TransactionTrade: 'TransactionTrade',
  TransactionSwap: 'TransactionSwap',
  TransactionDeposit: 'TransactionDeposit',
  TransactionWithdrawal: 'TransactionWithdrawal',
  TransactionFee: 'TransactionFee',
  TransactionFill: 'TransactionFill',
  PortfolioValue: 'PortfolioValue',
  EnlistedUsers: 'EnlistedUsers',
  Partner: 'Partner',
  PartnerMember: 'PartnerMember',
  Tournament: 'Tournament',
  CoinMarketData: 'CoinMarketData',
  PostStats: 'PostStats',
  PortfolioAssetTransactionView: 'PortfolioAssetTransactionView',
  FirstCreatedPortfoliosView: 'FirstCreatedPortfoliosView'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }

        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
